import React from 'react';

type ButtonSize = 'sm' | 'md' | 'lg';
type ButtonVariant = 'solid' | 'outline' | 'ghost';

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  size?: ButtonSize;
  variant?: ButtonVariant;
  rounded?: boolean;
  full?: boolean;
  loading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
};

const sizeClassMap: Record<ButtonSize, string> = {
  sm: 'butn butn-md',
  md: 'butn butn-md',
  lg: 'butn butn-md',
};

const variantClassMap: Record<ButtonVariant, string> = {
  solid: 'butn-bg main-colorbg text-dark',
  outline: 'butn-bord',
  ghost: '',
};

export const CustomModified: React.FC<ButtonProps> = ({
  size = 'md',
  variant = 'solid',
  rounded = true,
  full = false,
  loading = false,
  leftIcon,
  rightIcon,
  className,
  children,
  disabled,
  ...rest
}) => {
  const radiusClass = rounded ? 'radius-30' : '';
  const fullClass = full ? 'butn-full' : '';
  const composed = [
    sizeClassMap[size],
    variantClassMap[variant],
    radiusClass,
    fullClass,
    className || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={composed}
      disabled={disabled || loading}
      {...rest}
    >
      <span className="text" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        {leftIcon ? <span>{leftIcon}</span> : null}
        <span>{loading ? '...' : children}</span>
        {rightIcon ? <span>{rightIcon}</span> : null}
      </span>
    </button>
  );
};

export default CustomModified;


